const StatCard = ({ title, value, delta, positive, negative }) => {
  let color = "text-gray-500";
  if (positive) {
    color = "text-green-600";
  } else if (negative) {
    color = "text-red-500";
  }

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <p className={`text-sm text-gray-600 mb-2  ${color} font-bold`}>{title}</p>
      <h2 className="text-3xl font-semibold mb-1">{value}</h2>
      <p className={`text-sm ${color}`}>
        {delta}
      </p>
    </div>
  );
};

export default StatCard;  